import { Col } from "design-react-kit";

const PrivacyPolicy = () => {
  return (
    <Col className="p-5" style={{ maxWidth: "1000px", margin: "auto", textAlign: "justify" }}>
      <h1>Privacy Policy</h1>
      <p>
        In questa pagina si descrivono le modalit&agrave; e le logiche del
        trattamento dei dati personali degli utenti (di seguito, anche gli&nbsp;
        <em>Utenti</em>) che accedono per via telematica al sito:&nbsp;
        <a href="https://performance.gov.it/">
          https://performance.gov.it/
        </a>{" "}
        (di seguito, anche <em>Sito</em>) e ai relativi servizi (di seguito
        &quot;Servizi&quot;).
      </p>

      <p>
        L&#39;informativa &egrave; resa ai sensi dell&#39;art. 13 del D. Lgs. n.
        196/2003 - Codice in materia di protezione dei dati personali a tutti
        gli utenti che, interagendo con il Sito, forniscono i propri dati
        personali.
      </p>

      <p>
        La validit&agrave; dell&rsquo;informativa contenuta nella presente
        pagina &egrave; limitata al solo Sito e non si estende ad altri siti web
        eventualmente consultabili mediante collegamento ipertestuale.
      </p>

      <p>Il titolare del trattamento dei dati raccolti &egrave;:</p>

      <p>
        <strong>
          Dipartimento della Funzione Pubblica
          <br />
          Palazzo Vidoni
          <br />
          Corso Vittorio Emanuele, 116
          <br />
          00186 Roma &ndash; Italia
        </strong>
      </p>

      <h2>Tipologia dei dati e finalit&agrave; del trattamento</h2>

      <p>
        Tutti i dati personali forniti attraverso il Sito saranno trattati in
        modo lecito e secondo correttezza al fine di fornire i servizi richiesti
        nonch&eacute; di rispondere alle comunicazioni e alle domande degli
        utenti, sempre nell&rsquo;assolvimento dei compiti istituzionali del
        Dipartimento della Funzione Pubblica cos&igrave; come previsti dalla
        Legge.
      </p>

      <p>
        Il conferimento dei dati personali &egrave; facoltativo. L&#39;eventuale
        rifiuto di conferirli pu&ograve; comportare l&#39;impossibilit&agrave;
        di utilizzare il Sito e fruire dei relativi Servizi.
      </p>

      <h2>Dati forniti volontariamente</h2>

      <p>
        Attraverso il Sito &egrave; possibile inviare richieste e comunicazioni
        al Dipartimento della Funzione Pubblica attraverso gli indirizzi di
        contatto riportati sul sito. Il conferimento di tali dati &egrave;
        obbligatorio, necessario per rispondere alle richieste inviate
        nonch&eacute; per ricontattare il mittente per ottenere precisazioni in
        ordine a quanto segnalato.
      </p>

      <p>
        L&rsquo;invio facoltativo, esplicito e volontario di posta elettronica
        agli indirizzi indicati nei differenti canali di accesso al sito e la
        compilazione dei format (maschere) comportano la successiva acquisizione
        dell&rsquo;indirizzo del mittente, necessario per rispondere alle
        richieste, nonch&eacute; degli eventuali altri dati personali inseriti
        nella missiva.
      </p>

      <h2>Dati di navigazione&nbsp;</h2>

      <p>
        In questa categoria di dati rientrano gli indirizzi IP o i nomi a
        dominio dei computer utilizzati dagli utenti che si connettono al sito,
        gli indirizzi in notazione URI (Uniform Resource Identifier) delle
        risorse richieste, l&#39;orario della richiesta, il metodo utilizzato
        nel sottoporre la richiesta al server, la dimensione del file ottenuto
        in risposta, il codice numerico indicante lo stato della risposta data
        dal server (buon fine, errore, ecc.) e altri parametri relativi al
        sistema operativo e all&#39;ambiente informatico dell&#39;utente. I dati
        di navigazione vengono acquisiti non per finalit&agrave; di
        identificazione degli utenti, ma all&rsquo;unico fine di raccogliere, in
        forma anonima, informazioni statistiche sull&rsquo;utilizzo del sito e
        dei suoi servizi.
      </p>

      <h2>Cookie</h2>

      <p>
        I&nbsp;<em>cookie</em>&nbsp;sono piccoli file di testo che i siti
        visitati inviano al terminale dell&#39;utente, dove vengono memorizzati,
        per poi essere ritrasmessi agli stessi siti alla visita successiva.
      </p>

      <p>Il Sito utilizza:</p>

      <ul>
        <li>
          <p>
            <em>cookie di sessione</em>&nbsp;il cui utilizzo non &egrave;
            strumentale alla raccolta di dati personali identificativi
            dell&#39;utente, essendo limitato alla sola trasmissione di dati
            identificativi di sessione nella forma di numeri generati
            automaticamente dal server. I cookie di sessione non sono
            memorizzati in modo persistente sul dispositivo dell&#39;utente e
            vengono cancellati automaticamente alla chiusura del browser;
          </p>
        </li>
        <li>
          <p>
            <em>cookies analytics</em> utilizzati per raccogliere informazioni,
            in forma aggregata, sul numero degli utenti e su come gli stessi
            visitano il Sito. Il Sito si avvale del servizio Google Analytics,
            la cui cookie policy pu&ograve; essere visionata all&#39;indirizzo{" "}
            <a href="https://support.google.com/analytics/answer/6004245">
              https://support.google.com/analytics/answer/6004245
            </a>
            . Al fine di rispettare la privacy dei nostri utenti, il servizio
            &egrave; utilizzato con la modalit&agrave; &quot;_anonymizeip&quot;
            che consente di mascherare gli indirizzi IP degli utenti che
            navigano sul sito internet (
            <a href="https://support.google.com/analytics/answer/2763052?hl=it">
              maggiori informazioni sulla funzionalit&agrave;
            </a>
            ). I dati sono raccolti all&rsquo;unico fine di elaborare
            informazioni statistiche anonime sull&rsquo;uso del Sito e per
            verificare il corretto funzionamento dello stesso; i dati di
            navigazione potrebbero essere utilizzati in vista
            dell&rsquo;identificazione dell&rsquo;utente solo nel caso in cui
            ci&ograve; fosse necessario per l&rsquo;accertamento di reati di
            natura informatica.
          </p>

          <p>
            L&rsquo;utente pu&ograve; disabilitare in modo selettivo
            l&rsquo;azione di Google Analytics installando sul proprio browser
            l&rsquo;apposito componente fornito da Google (opt out). Per
            disabilitare la raccolta di dati da parte di Google Analytics, si
            rinvia al link di seguito indicato:{" "}
            <a href="https://tools.google.com/dlpage/gaoptout">
              https://tools.google.com/dlpage/gaoptout
            </a>
            .
          </p>
        </li>
      </ul>

      <p>
        I&nbsp;<em>cookie</em>&nbsp;utilizzati non consentono la raccolta di
        informazioni personali relative all&#39;utente. Non sono utilizzati
        cookies per la profilazione dell&#39;utente. L&#39;utente pu&ograve;
        scegliere di abilitare o disabilitare i&nbsp;<em>cookie</em>
        &nbsp;intervenendo sulle impostazioni del proprio browser di navigazione
        secondo le istruzioni dei fornitori. La disabilitazione dei&nbsp;
        <em>cookie</em>&nbsp;di sessione comporta l&#39;impossibilit&agrave; per
        l&#39;utente di autenticarsi in eventuali aree riservate del sito.
      </p>

      <h2>Diritti degli interessati</h2>

      <p>
        Gli Utenti possono esercitare in qualsiasi momento i diritti previsti
        dall&rsquo;art. 7 del Codice privacy, di seguito riportato
        integralmente:
      </p>

      <p>
        <em>Art. 7 D. Lgs. 30 giugno 2003, n. 196</em>
      </p>

      <p>
        L&#39;interessato ha diritto di ottenere la conferma dell&#39;esistenza
        o meno di dati personali che lo riguardano, anche se non ancora
        registrati, e la loro comunicazione in forma intelligibile.
      </p>

      <p>L&#39;interessato ha diritto di ottenere l&#39;indicazione:</p>

      <ol style={{ listStyleType: "lower-alpha" }}>
        <li>
          <p>dell&#39;origine dei dati personali;</p>
        </li>
        <li>
          <p>delle finalit&agrave; e modalit&agrave; del trattamento;</p>
        </li>
        <li>
          <p>
            della logica applicata in caso di trattamento effettuato con
            l&#39;ausilio di strumenti elettronici;
          </p>
        </li>
        <li>
          <p>
            degli estremi identificativi del titolare, dei responsabili e del
            rappresentante designato ai sensi dell&#39;articolo 5, comma 2;
          </p>
        </li>
        <li>
          <p>
            dei soggetti o delle categorie di soggetti ai quali i dati personali
            possono essere comunicati o che possono venirne a conoscenza in
            qualit&agrave; di rappresentante designato nel territorio dello
            Stato, di responsabili o incaricati.
          </p>
        </li>
      </ol>

      <p>L&#39;interessato ha diritto di ottenere:</p>

      <ol style={{ listStyleType: "lower-alpha" }}>
        <li>
          <p>
            l&#39;aggiornamento, la rettificazione ovvero, quando vi ha
            interesse, l&#39;integrazione dei dati;
          </p>
        </li>
        <li>
          <p>
            la cancellazione, la trasformazione in forma anonima o il blocco dei
            dati trattati in violazione di legge, compresi quelli di cui non
            e&#39; necessaria la conservazione in relazione agli scopi per i
            quali i dati sono stati raccolti o successivamente trattati;
          </p>
        </li>
        <li>
          <p>
            l&#39;attestazione che le operazioni di cui alle lettere a) e b)
            sono state portate a conoscenza, anche per quanto riguarda il loro
            contenuto, di coloro ai quali i dati sono stati comunicati o
            diffusi, eccettuato il caso in cui tale adempimento si rivela
            impossibile o comporta un impiego di mezzi manifestamente
            sproporzionato rispetto al diritto tutelato
          </p>
        </li>
      </ol>

      <p>L&#39;interessato ha diritto di opporsi, in tutto o in parte:</p>

      <ol style={{ listStyleType: "lower-alpha" }}>
        <li>
          <p>
            per motivi legittimi al trattamento dei dati personali che lo
            riguardano, ancorch&eacute; pertinenti allo scopo della raccolta;
          </p>
        </li>
        <li>
          <p>
            al trattamento di dati personali che lo riguardano a fini di invio
            di materiale pubblicitario o di vendita diretta o per il compimento
            di ricerche di mercato o di comunicazione commerciale.
          </p>
        </li>
      </ol>

      <p>
        Le richieste possono essere inviate ai seguenti indirizzi: email:{" "}
        <a href="mailto:performance@governo.it">performance@governo.it</a>, pec:{" "}
        <a href="mailto:protocollo_dfp@mailbox.governo.it">
          protocollo_dfp@mailbox.governo.it
        </a>
      </p>

      <p>
        Attraverso i medesimi recapiti, l&rsquo;Utente potr&agrave; chiedere
        inoltre la lista aggiornata di tutti i Responsabili del trattamento
        nominati dal Titolare.
      </p>

      <h2>Aggiornamenti</h2>

      <p>
        La Privacy Policy di questo Sito &egrave; soggetta ad aggiornamenti; gli
        Utenti sono pertanto invitati a verificarne periodicamente il contenuto.
        &nbsp;
      </p>
    </Col>
  );
};

export default PrivacyPolicy;